import { Copy, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export const NewKeyDialog = ({ created, onClose }) => {
  const copy = async () => {
    try { await navigator.clipboard.writeText(created.api_key); toast.success("Key copied"); }
    catch { toast.error("Copy failed — select and copy manually"); }
  };
  return (
    <Dialog open={!!created} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="new-key-dialog" className="max-w-lg bg-[#0F172A] border-slate-700 text-slate-100">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl flex items-center gap-2"><KeyRound className="h-5 w-5 text-emerald-400" />Key created · {created?.name}</DialogTitle>
          <DialogDescription className="text-amber-400">Copy it now. For security it will never be shown again.</DialogDescription>
        </DialogHeader>
        <code data-testid="new-key-value" className="block font-mono text-sm break-all bg-[#080C14] border border-slate-700 rounded-md p-3 text-emerald-300 select-all">{created?.api_key}</code>
        <p className="text-xs text-slate-500">Send it in the <span className="font-mono">X-API-Key</span> header. Keep it on servers only, never in browser or mobile app code.</p>
        <DialogFooter>
          <Button data-testid="new-key-copy-button" onClick={copy} className="bg-indigo-500 hover:bg-indigo-600"><Copy className="h-4 w-4 mr-2" />Copy key</Button>
          <Button data-testid="new-key-done-button" variant="ghost" onClick={onClose} className="text-slate-300 hover:bg-slate-800 hover:text-white">Done</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
